import { FC } from "preact/compat";
import { useEffect } from "preact/hooks";
import { useSignal } from "@preact/signals";
import WarnIcon from "@material-design-icons/svg/outlined/warning.svg";

const TOO_LONG_DELAY = 4000;

const RouteLoading: FC = () => {
    const tooLong = useSignal(false);

    useEffect(() => {
        const tmId = window.setTimeout(() => {
            tooLong.value = true;
        }, TOO_LONG_DELAY);

        return () => {
            window.clearTimeout(tmId);
        };
    }, [tooLong]);

    return (
        <div className="h-full bg-white relative flex items-center justify-center">
            {tooLong.value && (
                <div className="flex flex-col justify-center items-center p-6 text-gray-500">
                    <WarnIcon
                        width="48"
                        height="48"
                        className="fill-current mb-4"
                    />
                    <span className="text-lg">
                        Your connection seems to be slow...
                    </span>
                    <span className="text-sm">
                        But we're still loading the app
                    </span>
                </div>
            )}
        </div>
    );
};

export default RouteLoading;
